const Index = () => import("./index.vue");
const CreatePage = () => import("./_pages/create.vue");
const ViewPage = () => import("./_pages/view.vue");

export default [
  {
    path: "/regions",
    component: Index,
  },
  {
    path: "/new-region",
    component: CreatePage,
  },
  {
    path: "/regions/:id",
    component: ViewPage,
  },
];